import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, ButtonGroup, Typography } from '@material-ui/core';
import AccountTreeOutlinedIcon from '@material-ui/icons/AccountTreeOutlined';
import ViewWeekOutlinedIcon from '@material-ui/icons/ViewWeekOutlined';
import TimelineIcon from '@material-ui/icons/Timeline';

import Spinner from '../../UI/Spinner/Spinner';
import armarCircuito from './armarCircuito';
import CircuitoArbol from './CircuitoArbol';
import CircuitoEtapas from './CircuitoEtapas';
import CircuitoLineaTiempo from './CircuitoLineaTiempo';
import colores from '../Bandeja/coloresBandeja';

const useStyles = makeStyles((theme) => ({
  barra: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '10px',
    marginBottom: '14px'
  },
  // En celular los tres botones ocupan el ancho, sin íconos y con el texto en dos líneas si hace falta.
  vistas: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      '& .MuiButton-root': {
        flex: 1,
        lineHeight: 1.2,
        padding: '4px 6px'
      },
      '& .MuiButton-startIcon': {
        display: 'none'
      }
    }
  },
  mensaje: {
    color: colores.tenue
  }
}));

const vistas = [
  { clave: 'arbol', nombre: 'Árbol', icono: AccountTreeOutlinedIcon, componente: CircuitoArbol },
  { clave: 'etapas', nombre: 'Por etapas', icono: ViewWeekOutlinedIcon, componente: CircuitoEtapas },
  { clave: 'lineaTiempo', nombre: 'Línea de tiempo', icono: TimelineIcon, componente: CircuitoLineaTiempo }
];

// La vista elegida se recuerda en el navegador; si el storage no está disponible se usa el árbol.
const CLAVE_VISTA = 'impresion.vistaCircuito';

const vistaGuardada = () => {
  try {
    const guardada = localStorage.getItem(CLAVE_VISTA);
    return vistas.some((vista) => vista.clave === guardada) ? guardada : vistas[0].clave;
  } catch (e) {
    return vistas[0].clave;
  }
};

const guardarVista = (clave) => {
  try {
    localStorage.setItem(CLAVE_VISTA, clave);
  } catch (e) {
    // Sin storage la elección dura hasta salir de la página.
  }
};

/**
 * Circuito del comprobante (los comprobantes que lo descargaron, hasta el final) en árbol, por etapas o en línea
 * de tiempo. raiz es el comprobante consultado; circuito, lo que devuelve loadCircuitoComprobanteImpresion.
 */
const CircuitoComprobante = ({ raiz, circuito, error }) => {
  const classes = useStyles();
  const [vista, setVista] = useState(vistaGuardada);
  const armado = useMemo(() => (circuito ? armarCircuito(raiz, circuito) : null), [raiz, circuito]);

  if (error) return <Typography color="error">{error}</Typography>;
  if (!armado) return <Spinner size="small" />;

  const elegir = (clave) => {
    setVista(clave);
    guardarVista(clave);
  };
  const Vista = vistas.find((item) => item.clave === vista).componente;

  return (
    <React.Fragment>
      <div className={classes.barra}>
        <Typography variant="body2" className={classes.mensaje}>
          {armado.todos.length > 1 ? `${armado.todos.length - 1} comprobantes en el circuito` : 'Todavía no tiene descargas'}
        </Typography>
        <ButtonGroup className={classes.vistas} size="small" color="primary">
          {vistas.map((item) => {
            const Icono = item.icono;
            return (
              <Button
                key={item.clave}
                variant={item.clave === vista ? 'contained' : 'outlined'}
                startIcon={<Icono fontSize="small" />}
                onClick={() => elegir(item.clave)}
              >
                {item.nombre}
              </Button>
            );
          })}
        </ButtonGroup>
      </div>
      <Vista circuito={armado} />
    </React.Fragment>
  );
};

export default CircuitoComprobante;
